export default __webpack_public_path__ + "static/media/gallery_00.3bf41801.jpg";